import { makeObservable } from 'mobx';

import type { TConstraints } from '@feathr/rachis';

import type { ICreativeAttributes } from './creatives_base';
import { Creative, CreativeClass } from './creatives_base';

// =============================================================================
// Partner Message Email Creative Types
// =============================================================================

export type TPartnerMessageEmailCreative = ICreativeAttributes;

// =============================================================================
// Partner Message Email Creative Class
// =============================================================================

/**
 * PartnerMessageEmailCreative handles partner message email creatives.
 */
export class PartnerMessageEmailCreative extends Creative<TPartnerMessageEmailCreative> {
  public readonly className = 'PartnerMessageEmailCreative';

  public override get constraints(): TConstraints<TPartnerMessageEmailCreative> {
    return super.constraints;
  }

  constructor(attributes: Partial<TPartnerMessageEmailCreative>) {
    super(attributes);

    makeObservable(this);
  }

  public override getDefaults(): Partial<TPartnerMessageEmailCreative> {
    return {
      ...super.getDefaults(),
      _cls: CreativeClass.PartnerMessageEmail,
    };
  }

  public override get name(): string {
    return this.get('name', '').trim() || 'Unnamed Creative';
  }
}
